import { ECheckDailyrentPriceActionTypes } from 'shared/actions/checkDailyrentPrice/types';
import { EDailyrentBookingCalendarActionTypes } from 'shared/actions/dailyrentBookingCalendar/types';
import { IDailyrentBookingCalendarState } from 'shared/store/dailyrentBookingParams/types';
import { IOfferData } from 'shared/types/offerData';
import { RootAction } from 'shared/types/redux/RootAction';

const initialState: IDailyrentBookingCalendarState = {
  isOpen: false,
  initialLoading: false,
  daysAvailability: [],
  showBookingCalendar: false,
  dateInputText: '',
  dates: {
    from: undefined,
    to: undefined,
  },
};

export const dailyrentBookingCalendarReducer = (
  state: IDailyrentBookingCalendarState = initialState,
  action: RootAction,
): IDailyrentBookingCalendarState => {
  switch (action.type) {
    case 'IOfferFetched': {
      const {
        offer: { dailyrent },
      } = action.offerData as IOfferData;

      const showBookingCalendar = dailyrent?.showBookingCalendar || false;
      const dateInputText = dailyrent?.dateInputText || '';

      return {
        ...state,
        showBookingCalendar,
        dateInputText,
      };
    }

    case EDailyrentBookingCalendarActionTypes.SetDates:
      return { ...state, dates: action.payload };

    case EDailyrentBookingCalendarActionTypes.ToggleCalendarModal: {
      const open = typeof action.payload === 'boolean' ? action.payload : !state.isOpen;

      return { ...state, isOpen: open };
    }

    case EDailyrentBookingCalendarActionTypes.SetInitialLoading:
      return { ...state, initialLoading: action.payload };

    case EDailyrentBookingCalendarActionTypes.SetDaysAvailability:
      return { ...state, daysAvailability: action.payload };

    case ECheckDailyrentPriceActionTypes.Success:
      return {
        ...state,
        dateInputText: action.payload.dateInputText,
      };

    case ECheckDailyrentPriceActionTypes.Fail:
      return { ...state };

    default:
      return state;
  }
};
